import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AsiaStockDetailClient.tsx");
